export const EMPLOYEES = 'employees';

export const ROOMS = 'rooms';

export const DEVICES = 'devices';
